import seedrandom from 'seedrandom';
export const getRng = (seed) => seedrandom(seed ? seed.toString() : Date.now().toString());
export const getRandomInt = (min, max, rng) => {
  const r = rng ? rng() : Math.random();
  return Math.floor(r * (max - min + 1)) + min;
};
export const shuffleArray = (array, rng) => {
  let currentIndex = array.length, randomIndex;
  const r = rng ? rng : Math.random;
  while (currentIndex !== 0) {
    randomIndex = Math.floor(r() * currentIndex);
    currentIndex--;
    [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
  }
  return array;
};
